import { useRouterState } from "@tanstack/react-router";

export const useIsArticlePage = () => {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  });

  /**
   * true if the current path ends with /news/[newsId]
   * todo: update regex to match on /news/[newsId] or /help/[articleId]
   */

  const regex = /.+\/news\/.+$/;
  return regex.test(pathname);
};
